/** @file Viewport session state: overlay toggles, the status notice and the unkeyed pose (never saved). */
import { createStore } from 'zustand/vanilla';
import type { PendingCommand } from '../../stores/types';
import type { OverlayToggles } from './scene/overlayOptionsFor';
import type { ViewportNotice } from './viewportTypes';

/** `unkeyed` holds Animate-mode keys a release did not commit because auto-key is off (R-E1-07). */
export interface ViewportState { toggles: OverlayToggles; notice: ViewportNotice | null; unkeyed: PendingCommand[] }

/** Bones, IK, sockets, axes and grid on; names, mesh and onion off. */
export const viewportStore = createStore<ViewportState>()(() => ({
  toggles: { bones: true, names: false, mesh: false, ik: true, sockets: true, axes: true, grid: true, onion: false },
  notice: null,
  unkeyed: [],
}));
